export default "__VITE_ASSET__Ys1ZAVZq__"